import React, { FormEvent, ReactElement } from 'react';
import {
  Col, FormGroup, Heading, Input, Label, LoaderButton, Row,
} from 'idsk-react-components';
import { BackButton, MultiInput } from 'slovlex-idsk-react-components';
import './terminCreateUpdateForm.scss';
import TerminCreate from '../../../../../model/TerminCreate';
import { SafeParameterSetter } from '../../../../../model/SafeParameterSetter';

interface Props {
  termin: TerminCreate;
  getFieldErrorMessage: (fieldName: string) => string | undefined;
  clearFieldErrorMessage?: (fieldName: string) => void;
  clearArrayFieldErrorMessage?: (fieldName: string) => void;
  onUpdateField: SafeParameterSetter<TerminCreate>;
  loading: boolean;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  mode: 'CREATE' | 'UPDATE';
}

const TerminCreateUpdateForm = ({
  termin,
  getFieldErrorMessage,
  clearFieldErrorMessage,
  clearArrayFieldErrorMessage,
  onUpdateField,
  loading,
  onSubmit,
  mode,
}: Props): ReactElement => {
  function isCreate(): boolean {
    return mode === 'CREATE';
  }

  function isUpdate(): boolean {
    return mode === 'UPDATE';
  }

  return (
    <>
      { isUpdate() && (<Heading size="l">Základné údaje</Heading>)}
      <form onSubmit={onSubmit} className="admin-termin-create-form">
        <FormGroup>
          <Row>
            <Col width="one-half">
              <Label htmlFor="preferovanyTermin">Preferovaný termín</Label>
            </Col>
          </Row>
          <Row>
            <Col width="one-half">
              <Input
                name="preferovanyTermin"
                type="text"
                maxLength={128}
                value={termin.preferovanyTermin}
                onChange={({ target }) => onUpdateField('preferovanyTermin', target.value)}
                error={getFieldErrorMessage('preferovanyTermin')}
              />
            </Col>
          </Row>
        </FormGroup>
        <FormGroup>
          <Row>
            <Col width="one-half">
              <MultiInput
                label="Alternatívne termíny (nepovinný údaj)"
                buttonTitle="+ Pridať ďalší"
                values={termin.alternativnyTerminList}
                hint="Môžete pridať viacero alternatívnych termínov."
                fieldName="alternativnyTermin"
                getFieldErrorMessage={getFieldErrorMessage}
                clearFieldErrorMessage={clearFieldErrorMessage}
                clearArrayFieldErrorMessage={clearArrayFieldErrorMessage}
                maxLength={128}
                onChange={(updatedData) => onUpdateField('alternativnyTerminList', updatedData)}
              />
            </Col>
          </Row>
        </FormGroup>
        <Row className="admin-termin-create__actions">
          <Col width="one-half">
            <LoaderButton
              className="admin-termin-create__create-button"
              loading={loading}
              type="submit"
              size="large"
            >
              {isCreate() ? 'Vytvoriť' : 'Uložiť zmeny'}
            </LoaderButton>
            <BackButton />
          </Col>
        </Row>
      </form>
    </>
  );
};

export default TerminCreateUpdateForm;
